import {
  DependentParams,
  EntityType,
  PortfolioReportParamDTO,
} from '../api/usePortfolioReportParamsQuery';

const ErrorMessageMap: Record<EntityType, string> = {
  [EntityType.Household]: '',
  [EntityType.Account]: 'An account must be selected first.',
  [EntityType.Registration]: 'A registration must be selected first.',
  [EntityType.PortfolioGroup]: 'A portfolio group must be selected first.',
};

/**
 * As it is currently, all fields are mandatory.
 * All fields are initially filled in, except the Entity select.
 * Entity select must be filled if EntityType is other than Household.
 * That is the only validation we need to do atm.
 */
export const validateParams = (
  params: PortfolioReportParamDTO[],
): { isValid: boolean; error?: string } => {
  const entityTypeSelectParam = params.find(({ name }) => name === DependentParams.EntityType);
  const entitySelectParam = params.find(({ name }) => name === DependentParams.Entity);

  if (!entityTypeSelectParam || !entitySelectParam) {
    return { isValid: true };
  }

  // If the entity type currently selected is Household, there is no entity select and so
  // params are always valid (since all of them are always filled).
  if (entityTypeSelectParam.values && entityTypeSelectParam.values[0] === EntityType.Household) {
    return { isValid: true };
  }

  // If Entity type is not household, entity needs to be filled in.
  if (entitySelectParam.values) {
    return { isValid: true };
  }

  return {
    isValid: false,
    error: entityTypeSelectParam.values ? ErrorMessageMap[entityTypeSelectParam.values[0]] : '',
  };
};
